import { createIcon } from '@chakra-ui/icons'
import React from 'react'
export const IconCheckmark = createIcon({
  displayName: 'IconCheckmark',
  path: [
    <path
      key="0"
      d="M11 17.41L5.29001 11.71L6.71001 10.29L11 14.59L20.29 5.29L21.71 6.71L11 17.41Z"
      fill="currentColor"
    />,
  ],
  viewBox: '0 0 24 24',
})
